import { render, staticRenderFns } from "./EmbedModal.vue?vue&type=template&id=2d42fb3b&"
import script from "./EmbedModal.vue?vue&type=script&lang=js&"
export * from "./EmbedModal.vue?vue&type=script&lang=js&"
import style0 from "./EmbedModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d42fb3b')) {
      api.createRecord('2d42fb3b', component.options)
    } else {
      api.reload('2d42fb3b', component.options)
    }
    module.hot.accept("./EmbedModal.vue?vue&type=template&id=2d42fb3b&", function () {
      api.rerender('2d42fb3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/dialog/EmbedModal.vue"
export default component.exports